import { LicenseDto } from "@/Common/Api/Labs/Dto/Responses/LicenseDto";
import { LabProcessingStatusFilterOption } from "@/Common/Models/Lab/Enum/LabProcessingStatusFilterOption";
import { PortalSyncStatus } from "@/Common/Models/Portal/Enums/PortalSyncStatus";
import { SortDirection } from "@/Common/Models/UI/Enums";

class LabCriteriasDTO {
    public Text: string;
    public Importance: number;
    public From: string;
    public To: string;
    public ToConsentDate: Date;
    public HealthCards: LabHealthCard[];
    public PatientLastName: string;
    public PatientDateOfBirth: Date;
    public Abnormality: boolean;
    public IsConsented: boolean;
    public ClinicianType: number[]; // 4 = where QueryingCMQNumber is type 4 (recipient), 5 = where QueryingCMQNumber is type 5 (cc)
    public UserLicenseNumber: LicenseDto;
    public LicenseNumbers: LicenseDto[];
    public IgnoreContextFilterForCurrentUser: boolean;
    public ContextFilter: string[];
    public SiteName: string;
    public Identifiers: string[];

    public PortalSyncUserContactIds: string[];
    public PortalSyncStatuses: PortalSyncStatus[];

    public Page: number;
    public PageSize: number;
    public IsPatientSearch: boolean;
    public PatientContactId: string;
    public IsNew: boolean;
    public IsSubmitted: boolean;
    public IsClassified: boolean;
    public IsSpecificSearch: boolean;
    public SpecificLabsIDs: string[];
    public RequestingUser_Name: string;
    public PatientFileLinkedLabFillerID: string[];
    public sortdirection: SortDirection;
    public ShowEnrolledPatientsResults: boolean;
    public HideResultsFiledByColleague: boolean;
    public AlwaysShowAbnormalResults: boolean;
    public SelectedLabProcessingStatuses: LabProcessingStatusFilterOption[];
}

class LabHealthCard {
    public Number: string;
    public HealthCardType: string;

    constructor(fields?: Partial<LabHealthCard>) {
        Object.assign(this, fields);
    }
}

export { LabCriteriasDTO, LicenseDto };
